var map = {
	"./dogtown.md": 263,
	"./job-one.md": 264,
	"./kirb.md": 265,
	"./structural-focus.md": 266,
	"./tiro-security.md": 267,
	"./youtube-auto-like.md": 268
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;


//////////////////
// WEBPACK FOOTER
// ./client/projects/data ^\.\/.*$
// module id = 262
// module chunks = 0